import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import '../styles/Tabs.css';

const Tabs = () => {
  const location = useLocation();

  const tabs = [
    { path: '/invite', label: 'Invite/Date' },
    { path: '/rsvp', label: 'RSVP' },
    { path: '/guests', label: 'Guest List' },
    { path: '/video', label: 'Video' },
    { path: '/photos', label: 'Photos' },
    { path: '/games', label: 'Games' },
  ];

  return (
    <div className="tabs-container">
      <nav className="tabs">
        {tabs.map((tab) => (
          <Link
            key={tab.path}
            to={tab.path}
            className={`tab ${location.pathname === tab.path ? 'active' : ''}`}
          >
            {tab.label}
          </Link>
        ))}
      </nav>
    </div>
  );
};

export default Tabs;
